import React from 'react';
import { Sun, SunMoon } from "lucide-react";

const ThemeToggle = ({ theme, toggleTheme }) => {
  const toggleButton = (isMobile = false) => {
    const baseClasses = "w-12 h-12  p-3 bg-white dark:bg-transparent rounded-full shadow-xl transition-colors duration-300 ";
    const desktopClasses = "hidden lg:block lg:top-24 lg:left-14 md:bottom-24 md:right-14 hover:bg-indigo-300 dark:hover:bg-indigo-800 ml-6";
    const mobileClasses = "block lg:hidden top-3 left-4 hover:bg-gray-200";

    return (
      <button
        className={`${baseClasses} ${isMobile ? mobileClasses : desktopClasses}`}
        onClick={toggleTheme}
        aria-label="Toggle Theme"
      >
        {theme === "dark" ? (
          <SunMoon className="text-gray-800 dark:text-gray-100" />
        ) : (
          <Sun className="text-gray-800 dark:text-gray-100" />
        )}
      </button>
    );
  };

  return (
    <>
      {/* Desktop Toggle */}
      {toggleButton()}
      
      {/* Mobile Toggle */}
      {toggleButton(true)}
    </>
  );
};

export default ThemeToggle;